import { CalendarNavigation } from './navigation'
import { Tabs } from '$components'
import { SettingsIcon } from '$components'
import { Outlet } from 'react-router'
import { PersonSelectFilter, Strategy } from '../../../../components/person-select'
import { useQuery } from '@tanstack/react-query'
import { userIndexOptions } from '$api-client/@tanstack/react-query.gen'
import { Role } from '$api-client/types.gen'
import { CalendarFilterParam } from '$features/calendar/enums/filter-params'
import { useCalendar } from '$features/calendar/hooks/use-calendar'
import { OptionsDropdown } from '$components'
import { CalendarViewType } from '$features/calendar/enums/view-type'

export function Calendar() {
  const { showWorkingDaysOnly, setShowWorkingDaysOnly, viewType } = useCalendar()

  const { data: staff } = useQuery({
    ...userIndexOptions({
      query: {
        roles: [Role.GROOMER, Role.ADMIN, Role.SUPER_ADMIN],
      },
    }),
  })

  const viewOptions = [
    showWorkingDaysOnly
      ? {
        id: 'all-days',
        value: 'Show all days',
        onClick: () => setShowWorkingDaysOnly(false),
      }
      : {
        id: 'working-days',
        value: 'Hide non-working days',
        onClick: () => setShowWorkingDaysOnly(true),
      },
  ]

  return (
    <div className="h-full grid grid-rows-[min-content,1fr] overflow-hidden">
      <div className="border-b border-gray-100 p-3 flex md:flex-row md:justify-between flex-col gap-3">
        <CalendarNavigation />

        <div className="flex items-center justify-between gap-2.5">
          <Tabs>
            <Tabs.Tab to="day">Day</Tabs.Tab>
            <Tabs.Tab to="week">Week</Tabs.Tab>
          </Tabs>

          <div className="flex-1">
            <PersonSelectFilter
              queryParamKey={CalendarFilterParam.PERSON_ID}
              options={staff?.data ?? []}
              strategy={Strategy.Query}
            />
          </div>

          { viewType === CalendarViewType.WEEK && (
            <OptionsDropdown
              icon={SettingsIcon}
              options={viewOptions}
            />
          )}
        </div>
      </div>

      <Outlet />
    </div>
  )
}
